import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.ExpenseEditPage`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Expense details',
  },
  expenseStatusBreadcrumb: {
    id: `${scope}.expenseStatusBreadcrumb`,
    defaultMessage: 'Expense status',
  },
})
